module.exports = __webpack_public_path__ + "static/pechuga-rellena-de-queso-1-92abdce0b049b48565a60fc2d0dd34a1.jpg";